var urlUtils = require('../utils/_urlUtils');

class mStoresCarousel extends HTMLDivElement {
    constructor() {
        super();
        this.onGeolocationGranted = this.onGeolocationGranted.bind(this);
    }

    connectedCallback() {
        if (this.dataset.geolocation === 'false') {
            navigator.geolocation.getCurrentPosition(this.onGeolocationGranted);
        }
    }

    onGeolocationGranted(position) {
        var url = this.dataset.geolocationUrl;
        url = urlUtils.appendToUrl(url, {
            lat: position.coords.latitude,
            long: position.coords.longitude
        });
        this.classList.add('loading');
        fetch(url, {
            method: 'GET'
        }).then((response) => {
            return response.json();
        }).then((responseData) => {
            if (responseData.found) {
                this.innerHTML = responseData.template;
            }
            this.classList.remove('loading');
        });
    }
}

customElements.define('m-stores-carousel', mStoresCarousel, {
    extends: 'div'
});
